import { Grid } from '@material-ui/core';
import { Typography } from 'fuse-ui';
import { withStyles } from '@material-ui/core/styles';
import Info from '@material-ui/icons/InfoOutlined';
import React from 'react';

import PropTypes from 'prop-types';

import { opacity } from '../common/theme/colors';

const styles = theme => ( {
    grid: {
        minHeight: '100vh'
    },
    icon: {
        color: opacity.black24
    },
    text: {
        maxWidth: 392,
        textAlign: 'center'
    }
} );
export const EmptyWidget = ( { classes, text, type } ) => (
    <Grid container item
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        className={classes.grid}>
        <Info classes={{ root: classes.icon }} />
        <Typography
            data-automation-id={`empty-widget-text-${type}`}
            variant="body1"
            color="textSecondary"
            className={classes.text}>
            {text}
        </Typography>
    </Grid>
);

EmptyWidget.propTypes = {
    classes: PropTypes.object.isRequired,
    text: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
};

export default withStyles( styles ) ( EmptyWidget );
